import '@core/assets/images/png/icon-pdf-actu.png';
import '@core/assets/images/png/icon-link-actu.png';
import BaseCard from '../base-card/base-card';

export default class NewsCard extends BaseCard {
  constructor(container) {
    super(container);
    this.selector = '.news-card';
  }
}
